import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
import Text from '../../../Text'
import { $layer2, $textInteractive, $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'

function ItemCountdownBF2025({ launchDate, stockLimit, stockLimitLeft, theme, subtitle }) {
  const [days, setDays] = useState(0)
  const [hrs, setHrs] = useState(0)
  const [mins, setMins] = useState(0)
  const [secs, setSecs] = useState(0)

  useEffect(() => {
    updateLaunchDate()
    setInterval(updateLaunchDate, 1000)
  }, [])

  function updateLaunchDate() {
    // Get current time
    const currentTime = new Date().getTime()
    const distance = launchDate - currentTime

    // Calculate remaining days, hours, minutes, and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)

    setDays(days)
    setHrs(hours)
    setMins(minutes)
    setSecs(seconds)
  }

  if (stockLimit) {
    return (
      <>
        <div className={styles.countdownWrapper} style={{ background: theme === 'dark' ? $layer2.dark : 'transparent' }}>
          <div className={styles.col} style={{ color: $textPrimary[theme || 'dark'] }}>
            {
              stockLimit > stockLimitLeft ?
                <div className="flex gap-2">
                  <div className="line-through decoration-red-500 decoration-4">
                    <Text type="heading-5" color={$textTertiary[theme || 'dark']}>{stockLimit}</Text>
                  </div>
                  <div className="flex items-center justify-center gap-1">
                    <Text type="heading-7" color={$textInteractive['light']}>{'<'}</Text>
                    <Text type="heading-5" color={$textInteractive['light']}>{stockLimitLeft}</Text>
                  </div>
                </div>
                : <Text type="heading-5" color={$textPrimary[theme || 'dark']}>{stockLimit}</Text>
            }
            <div className={styles.colText}><Text type="tiny" color={$textPrimary[theme || 'dark']}>Units only!</Text></div>
          </div>
        </div>
        { !!subtitle && <div className="text-center"><Text type="small" color={$textPrimary[theme || 'dark']}>{subtitle}</Text></div> }
      </>
    )
  } else {
    return (
      <div className={styles.countdownWrapper} style={{ background: theme === 'dark' ? $layer2.dark : 'transparent' }}>
        <div className={styles.col} style={{ color: $textPrimary['dark'] }}>
          <Text type="heading-5" color={$textPrimary[theme || 'dark']}>{days < 10 ? `0${days}` : days}</Text>
          <div className={styles.colText}><Text type="tiny" color={$textPrimary[theme || 'dark']}>Days</Text></div>
        </div>
        <div className={styles.separatorLine}/>
        <div className={styles.col} style={{ color: $textPrimary['dark'] }}>
          <Text type="heading-5" color={$textPrimary[theme || 'dark']}>{hrs < 10 ? `0${hrs}` : hrs}</Text>
          <div className={styles.colText}><Text type="tiny" color={$textPrimary[theme || 'dark']}>Hrs</Text></div>
        </div>
        <div className={styles.separatorLine}/>
        <div className={styles.col} style={{ color: $textPrimary['dark'] }}>
          <Text type="heading-5" color={$textPrimary[theme || 'dark']}>{mins < 10 ? `0${mins}` : mins}</Text>
          <div className={styles.colText}><Text type="tiny" color={$textPrimary[theme || 'dark']}>Mins</Text></div>
        </div>
        <div className={styles.separatorLine}/>
        <div className={styles.col} style={{ color: $textPrimary['dark'] }}>
          <Text type="heading-5" color={$textPrimary[theme || 'dark']}>{secs < 10 ? `0${secs}` : secs}</Text>
          <div className={styles.colText}><Text type="tiny" color={$textPrimary[theme || 'dark']}>Secs</Text></div>
        </div>
      </div>
    )
  }
}

export default ItemCountdownBF2025
